<template>
  <div class="captcha" @click="refreshCaptcha">
    <img v-if="image" :src="image" alt="captcha" />
    <div v-else class="loading">...</div>
  </div>
</template>

<script>
export default {
  name: 'Captcha',
  data() {
    return {
      image: '',
      captchaKey: '',
      loading: false,
    }
  },
  mounted() {
    this.refreshCaptcha()
  },
  methods: {
    getKey() {
      return this.captchaKey
    },
    refreshCaptcha() {
      if (this.loading) return
      this.loading = true
      this.$http({
        method: 'get',
        url: 'member_captcha',
      })
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.image = res.data.image || ''
            this.captchaKey = res.data.key || ''
            this.$emit('change', this.captchaKey)
            return
          }
          this.$toast(res.msg || this.$t('请求.请求失败'))
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="less" scoped>
.captcha {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 88px;
  border-radius: 12px;
  overflow: hidden;
  border: 2px solid #766350;
  background: #2a2a2a;
  cursor: pointer;
  box-sizing: border-box;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: fill;
  }

  .loading {
    color: #e6b98a;
    font-size: 28px;
  }
}
</style>